module.exports = __webpack_public_path__ + "static/media/logo-w.cf9f641d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bebanca/logo-w.svg
// module id = 1053
// module chunks = 0